
export default {
  name: 'HomologationWarningBadge',
  props: {
    variant: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldShow() {
      const userCountry = this.$auth.loggedIn && this.$auth.user
        ? this.$store.$auth.user.country.iso
        : this.$store.state.country
      const isGermany = ['DE'].includes(userCountry)
      const isNotHomologated = !this.variant.is_homologated
      return isGermany && isNotHomologated
    },
  },
}
